import { useMemo } from 'react';
import { QrCodeIcon } from '@phosphor-icons/react';
import { Card } from '@/components/ui/card';
import { useSceneHealth } from '@/hooks/useSceneHealth';
import { usePublishedDevices } from '@/hooks/usePublishedDevices';
import { deviceBlockStateFromVerdicts } from '@/modules/sceneHealth';
import { SharePanel } from './SharePanel';
import type { AnchorCategory, PublishDevice } from './types';
import { CardHeading } from '@/components/ui/card';

interface Props {
  sceneInstanceId: string;
  anchorCategory?: AnchorCategory;
}

export function StoryShareCard({ sceneInstanceId, anchorCategory }: Props) {
  const { data: sceneHealth } = useSceneHealth(sceneInstanceId);
  const { loading: devicesLoading } = usePublishedDevices(sceneInstanceId);

  const partialBlocks = useMemo(
    () => Object.fromEntries(deviceBlockStateFromVerdicts(sceneHealth?.verdicts).partialBlocks) as Partial<Record<PublishDevice, string>>,
    [sceneHealth],
  );

  return (
    <Card>
      <CardHeading as="h2" icon={<QrCodeIcon />} title="Share" />
      {devicesLoading ? (
        <div className="flex items-center justify-center py-10 font-lureo-font-prose text-lureo-14 text-lureo-ink-subtle">
          Loading…
        </div>
      ) : (
        <SharePanel
          sceneInstanceId={sceneInstanceId}
          partialBlocks={partialBlocks}
          anchorCategory={anchorCategory}
          qrSize={180}
        />
      )}
    </Card>
  );
}
